module.exports = __webpack_public_path__ + "img/extLow.a31ef71d.webp";